import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/components/shared/ContentAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/.pnpm/next-intl@4.8.3_next@15.5.12_react-dom@19.2.4_react@19.2.4__react@19.2.4__react@19.2.4_typescript@5.9.3/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
